import { Stack } from '@mui/material';
import { Partner } from '@provision/entity-types';
import { EditorEvents } from '@provision/rich-text-editor';
import { useMemo } from 'react';
import { isNullish } from 'remeda';
import { RichTextField } from 'src/components/Forms/RichTextField/rich-text-field';
import { NullableDeepPartial } from 'src/graphql/types';

interface SupportNotesTabProps {
  partner: NullableDeepPartial<Pick<Partner, 'partnerId' | 'partnerOnesheet'>>;
  onFieldChange: (field: string, value: string) => void;
  readonly: boolean;
}

export const SupportNotesTab = ({
  partner,
  onFieldChange,
  readonly,
}: SupportNotesTabProps) => {
  const partnerDetails = partner?.partnerOnesheet?.[0];

  const fields = useMemo(() => {
    if (isNullish(partner?.partnerId)) {
      return [];
    }

    return [
      {
        label: 'Support Notes',
        editorOptions: {
          editable: !readonly,
          onUpdate: ({ editor }: EditorEvents['update']) => {
            onFieldChange('whatIsYourEquipmentRepairPolicy', editor.getHTML());
          },
          content: partnerDetails?.whatIsYourEquipmentRepairPolicy ?? '',
        },
        dependencies: [partner.partnerId],
      },
      {
        label: 'RSM and Other Services',
        editorOptions: {
          editable: !readonly,
          onUpdate: ({ editor }: EditorEvents['update']) => {
            onFieldChange('primaryRsmTool', editor.getHTML());
          },
          content: partnerDetails?.primaryRsmTool ?? '',
        },
        dependencies: [partner.partnerId],
      },
    ];
  }, [
    readonly,
    partner.partnerId,
    partnerDetails?.whatIsYourEquipmentRepairPolicy,
    partnerDetails?.primaryRsmTool,
    onFieldChange,
  ]);

  return (
    <Stack spacing={3} sx={{ paddingTop: 2 }}>
      {fields.map((field) => (
        <RichTextField
          key={field.label}
          label={field.label}
          editorOptions={field.editorOptions}
          dependencies={field.dependencies}
        />
      ))}
    </Stack>
  );
};
